import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { Wrapper } from './styles/Wrapper';
import { GetUserDetailsOrgRelationDto, GetUserDetailsResultDto } from 'app/API';

type TProps = {
  user?: GetUserDetailsResultDto;
};

export const Organizations = ({ user }: TProps) => {
  if (!user) {
    return null;
  }

  const renderOrganization = (organization: GetUserDetailsOrgRelationDto) => {
    return (
      <div className="organization" key={organization.id}>
        <EntityIcon
          className="organization-shortName"
          name={organization.name || organization.slug}
          src={organization.image ?? undefined}
        />
        <div className="organization-right">
          <div className="organization-name">{organization.name}</div>
          <div className="organization-usersCount">
            {organization.userCount} {organization.userCount === 1 ? 'member' : 'members'}
          </div>
        </div>
      </div>
    );
  };

  return (
    <Wrapper>
      <LeftSide>
        <h3>Organization memberships</h3>
      </LeftSide>

      <RightSide>{(user.orgRelations || []).map((organization) => renderOrganization(organization))}</RightSide>
    </Wrapper>
  );
};
